import { GET_ARTMKT } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {


    switch (action.type) {

        case GET_ARTMKT + "_SUCCESS":

            return action.payload.data;

        default:
            return state;
    }
}